import { render, staticRenderFns } from "./Zxdj.vue?vue&type=template&id=54cfadb2"
import script from "./Zxdj.vue?vue&type=script&lang=js"
export * from "./Zxdj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports